export const getRecaptchaToken = async (action) => {
  if (window.grecaptcha) {
    try {
      const token = await window.grecaptcha.execute('6LeVYLIZAAAAAFAw_OyLDWpQtJM_5JD3qShWIeBV', {
        action: action
      });
      return token;
    } catch (error) {
      console.error('reCAPTCHAトークン取得エラー:', error);
      return null;
    }
  }
  return null;
};

export const initializeRecaptcha = async (action) => {
  if (!window.grecaptcha) {
    console.error('reCAPTCHAが読み込まれていません');
    return null;
  }

  try {
    // grecaptcha.ready()が完了するのを待つ
    await new Promise((resolve) => window.grecaptcha.ready(resolve));
    
    // トークンを取得
    const token = await window.grecaptcha.execute('6LeVYLIZAAAAAFAw_OyLDWpQtJM_5JD3qShWIeBV', {
      action: action
    });
    
    return token;
  } catch (error) {
    console.error('reCAPTCHAトークン取得エラー:', error);
    return null;
  }
};